import React from 'react';

export const SocialMediaToolkit: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-medium mb-4">Social Media Toolkit</h3>
        <p className="text-gray-600">Social media templates and tools coming soon...</p>
      </div>
    </div>
  );
}; 